import app from '@/app';
import templateUrl from './plans-create-button.html';

var component = {
	templateUrl,
	require: {
		form: '^form'
	},
	bindings: {
		soft: '<',
		disabled: '<',
		readonly: '<',
		onAccept: '&',
		onReject: '&'
	}
};

app.component('prPlansCreateButton', component);
